import { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { collectionData } from "../utils/collectionData";

const AUTOPLAY_MS = 8000;

const Slideshow = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            setIndex((i) => (i + 1) % collectionData.length);
        }, AUTOPLAY_MS);
        return () => clearInterval(id);
    }, []);

    const goTo = (i: number) => {
        setIndex((i + collectionData.length) % collectionData.length);
    };

    if (collectionData.length === 0) return null;

    return (
        <div className="w-full mb-8">
            <div className="relative rounded-2xl overflow-hidden shadow-md border border-[#e5ddd4] min-h-[280px] sm:min-h-[320px] bg-gradient-to-br from-white to-[#faf8f5]">
                {/* Carousel track */}
                <div
                    className="flex transition-transform duration-500 ease-out"
                    style={{ transform: `translateX(-${index * 100}%)` }}
                >
                    {collectionData.map((slide, i) => (
                        <div
                            key={i}
                            className="w-full flex-shrink-0 flex flex-col sm:flex-row min-h-[280px] sm:min-h-[320px]"
                        >
                            <div className="flex-1 flex flex-col justify-center p-8 sm:p-10 order-2 sm:order-1">
                                <h2 className="text-2xl sm:text-3xl font-extrabold text-[#704e37] mb-3">
                                    {slide.title}
                                </h2>
                                <p className="text-gray-600 text-base sm:text-lg leading-relaxed max-w-xl">
                                    {slide.description}
                                </p>
                            </div>
                            <div className="w-full sm:w-2/5 flex items-center justify-center p-8 sm:p-6 order-1 sm:order-2 bg-white/60">
                                <img
                                    src={slide.image}
                                    alt=""
                                    className="h-28 sm:h-40 w-auto object-contain"
                                />
                            </div>
                        </div>
                    ))}
                </div>

                {/* Prev / Next */}
                {collectionData.length > 1 && (
                    <>
                        <button
                            type="button"
                            onClick={() => goTo(index - 1)}
                            className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center text-[#704e37] hover:bg-white transition z-10"
                            aria-label="Slide paraardhës"
                        >
                            <FaChevronLeft className="text-lg" />
                        </button>
                        <button
                            type="button"
                            onClick={() => goTo(index + 1)}
                            className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center text-[#704e37] hover:bg-white transition z-10"
                            aria-label="Slide tjetër"
                        >
                            <FaChevronRight className="text-lg" />
                        </button>
                    </>
                )}
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-2.5 mt-4">
                {collectionData.map((_, i) => (
                    <button
                        key={i}
                        type="button"
                        onClick={() => setIndex(i)}
                        className={`rounded-full transition-all ${i === index ? "w-8 h-2.5 bg-[#704e37]" : "w-2.5 h-2.5 bg-[#704e37]/40 hover:bg-[#704e37]/60"}`}
                        aria-label={`Slide ${i + 1}`}
                        aria-current={i === index ? "true" : undefined}
                    />
                ))}
            </div>
        </div>
    );
};

export default Slideshow;
